import { RootState } from '../../../stores/store.ts';

export const selectAccountReminderByTargetId = (targetId: string) => (state: RootState) => {
    if (!targetId) return undefined;
    console.log(state.reminders.items);
    return state.reminders.items.find(
        (item) => item.targetId === targetId
    );
};